import * as React from "react";
import PropTypes from "prop-types";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import { Typography } from "@mui/material";
import { visuallyHidden } from "@mui/utils";
import { Box, Paper, IconButton } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import MyButton from "../MuiReusableComponents/MuiButton/buttonMUI";
import ArchiveIcon from "@mui/icons-material/Archive";
/////////////////////
import { useDispatch } from "react-redux";
import { readStringDate } from "../../function utils/functionUtils";
import { startDeleteEmployeePayrollCTC } from "../../store1/payrolls data/payrollDataSlice.Selector";
function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}
////
function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}
////
// This method is created for cross-browser compatibility, if you don't
// need to support IE11, you can use Array.prototype.sort() directly
function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}
const formatNumber = (number) => {
  const formattedNumber = new Intl.NumberFormat("en-IN").format(number);
  return formattedNumber;
};
const formatCurrency = (value) => {
  const formattedValue = parseFloat(value).toFixed(2);
  const parts = formattedValue.toString().split('.');
  const integerPart = formatNumber(parts[0]);
  const decimalPart = parts[1] || '00';
  return `${integerPart}.${decimalPart}`;
};

/////Component Needed
function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort, headCells } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => {
          if (headCell.id === "id" || headCell.id === "added_date") {
            return (
              <TableCell
                sx={{ fontWeight: "bold !important" }}
                key={headCell.id}
                align={"left"}
                padding={headCell.disablePadding ? "none" : "normal"}
                sortDirection={orderBy === headCell.id ? order : false}
              >
                <TableSortLabel
                  active={orderBy === headCell.id}
                  direction={orderBy === headCell.id ? order : "asc"}
                  onClick={createSortHandler(headCell.id)}
                >
                  {headCell.label}
                  {orderBy === headCell.id ? (
                    <Box component="span" sx={visuallyHidden}>
                      {order === "desc" ? "sorted descending" : "sorted ascending"}
                    </Box>
                  ) : null}
                </TableSortLabel>
              </TableCell>
            );
          }
          return (
            <TableCell
              sx={{ fontWeight: "bold !important" }}
              key={headCell.id}
              align={"right"}
              padding={headCell.disablePadding ? "none" : "normal"}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === "desc" ? "sorted descending" : "sorted ascending"}
                  </Box>
                ) : null}
              </TableSortLabel>
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
}
///
EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

////Component Needed
const ArchiveIconButton = ({ handleClickOpen, formDefaultData }) => {
  const { row } = formDefaultData;

  return (
    <IconButton
      disabled={!row.annual_ctc}
      aria-label="ArchiveIcon"
      title="Archive The Existing Payroll"
      onClick={() => {
        handleClickOpen();
      }}
    >
      <ArchiveIcon />
    </IconButton>
  );
};
///
///////Component Needed
const ConfirmMessage = ({ formDefaultData, setPopUpBool }) => {
  const { row } = formDefaultData;

  const dispacth = useDispatch();
  return (
    <>
      <Box sx={{ padding: "10px 5px" }}>
        <Typography>Do you want to Archive this record ?</Typography>
      </Box>
      <Box sx={{ p: "10px 0 0 0" }}>
        <MyButton
          size="small"
          onClick={() => {
            dispacth(startDeleteEmployeePayrollCTC(row));
            setPopUpBool(false);
          }}
          variant="contained"
        >
          Yes{" "}
        </MyButton>
        <MyButton
          size="small"
          sx={{ marginLeft: "20px" }}
          onClick={() => {
            setPopUpBool(false);
          }}
        >
          No
        </MyButton>
      </Box>
    </>
  );
};
/////Main Component
export default function TableSortingAndSelect({
  headCells,
  rows,
  setisItNewAdd
}) {

  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("employeeId");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  return (
    <Box sx={{ width: "100%" }}>
      <Paper sx={{ mb: 2, padding: "10px", width: "100%" }}>
        <TableContainer>
          <Table
            sx={{ minWidth: 750 }}
            aria-labelledby="tableTitle"
            size="small"
          >
            <EnhancedTableHead
              headCells={headCells}
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
            />
            <TableBody>
              {/* if you don't need to support IE11, you can replace the `stableSort` call with:
                 rows.slice().sort(getComparator(order, orderBy)) */}
              {stableSort(rows, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, idx) => {
                  return (
                    <TableRow size="small" hover key={idx}>
                      {headCells.map((head, indexHead) => {

                        if (head.id === "added_date") {
                          return (
                            <TableCell
                              key={`${idx}${indexHead}`}
                              size="small"
                              align="left"
                            >
                              {`${readStringDate(row[head.id])}`}
                            </TableCell>
                          );
                        }
                        if (head.id === "id") {
                          return (
                            <TableCell
                              key={`${idx}${indexHead}`}
                              size="small"
                              align="left"
                            // sx={{ width: "50px" }}
                            >

                              {idx + 1}
                            </TableCell>
                          );
                        }
                        if (
                          head.id === "annual_ctc" ||
                          head.id === "final_basic" ||
                          head.id === "hra" ||
                          head.id === "special_allowance" ||
                          head.id === "fixed"
                        ) {
                          const value = row[head.id];

                          return (
                            <TableCell
                              key={`${idx}${indexHead}`}
                              size="small"
                              align="right"
                              sx={{ paddingRight: "16px" }}
                            >
                              {value === null || value === undefined
                                ? "----"
                                : head.id === "final_basic"
                                  ? formatNumber(Math.round(value))
                                  : formatCurrency(value)}
                            </TableCell>
                          );
                        }

                        return (
                          <TableCell
                            size="small"
                            key={`${idx}${indexHead}`}
                            align="left"
                          >
                            {row[head.id]}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
              {emptyRows > 0 && (
                <TableRow
                  size="small"
                  style={{
                    height: 53 * emptyRows,
                  }}
                >
                  <TableCell size="small" colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 35]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </Box>
  );
}
